<template>
    <el-input
        v-model="innerValue"
        @input="onPendingValueChanged"
        v-bind="$attrs"
    ></el-input>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
      },
      delay: {
        type: Number,
        default: 400,
      }
    },

    data() {
      return {
        innerValue: null,
        debouncedValueApply: _.debounce(function () {
          this.$emit('input', this.innerValue);
        }, this.delay),
      };
    },

    watch: {
      value: {
        handler(val) {
          this.innerValue = val;
        },
        immediate: true,
      },
    },

    methods: {
      /**
       * @param {String} value
       */
      onPendingValueChanged(value) {
        this.debouncedValueApply();
        if (_.size(value) === 0) {
          this.debouncedValueApply.flush();
        }
      },
    },
  }
</script>

